export default "__VITE_ASSET__BqVvnrrJ__"